import { render, staticRenderFns } from "./AssignAdmin.vue?vue&type=template&id=ce90b106&"
import script from "./AssignAdmin.vue?vue&type=script&lang=js&"
export * from "./AssignAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports